export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8716.b4727325.jpg";